import type { JSX } from "react";
import { useTranslation } from "react-i18next";
import { planDisplayName } from "@/lib/plan-name";
import { useAuthStore } from "@/store/auth.store";
import { planDateLine } from "./plan";
import { PlanStatusChip } from "./SettingsCard";
import { planDateText } from "./SubscriptionPanel";

// The plan line under the Settings title: "Free Trial · Active · Free
// minutes reset on November 20, 2026".
export const PlanSummary = (): JSX.Element | null => {
  const { t, i18n } = useTranslation();
  const userData = useAuthStore((state) => state.userData);
  if (!userData?.planName) return null;
  const date = planDateText(
    t as never,
    planDateLine(userData),
    i18n.resolvedLanguage || i18n.language || "en",
  );
  return (
    <span
      className="inline-flex flex-wrap items-center gap-x-2 gap-y-1"
      data-testid="settings-plan-summary"
    >
      <span className="font-semibold text-v3-text">
        {planDisplayName(userData.planName)}
      </span>
      <PlanStatusChip status={userData.planStatus} />
      {date && <span>{date}</span>}
    </span>
  );
};
